var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResizeAuto',{ref:"ResizeAuto",scopedSlots:_vm._u([{key:"default",fn:function({ resize }){return [_c('textarea',{ref:"StyledTextArea",class:{ invalid: !_vm.state },attrs:{"rows":"1","state":_vm.state,"size":"sm","maxlength":_vm.limitInputLength(),"no-auto-shrink":""},domProps:{"value":_vm.value},on:{"input":_vm.update,"focus":resize}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }